const subnetMaskOptions = [
    { mask: '0.0.0.0', maskBits: 0 },
    { mask: '128.0.0.0', maskBits: 1 },
    { mask: '192.0.0.0', maskBits: 2 },
    { mask: '224.0.0.0', maskBits: 3 },
    { mask: '240.0.0.0', maskBits: 4 },
    { mask: '248.0.0.0', maskBits: 5 },
    { mask: '252.0.0.0', maskBits: 6 },
    { mask: '254.0.0.0', maskBits: 7 },
    { mask: '255.0.0.0', maskBits: 8 },
    { mask: '255.128.0.0', maskBits: 9 },
    { mask: '255.192.0.0', maskBits: 10 },
    { mask: '255.224.0.0', maskBits: 11 },
    { mask: '255.240.0.0', maskBits: 12 },
    { mask: '255.248.0.0', maskBits: 13 },
    { mask: '255.252.0.0', maskBits: 14 },
    { mask: '255.254.0.0', maskBits: 15 },
    { mask: '255.255.0.0', maskBits: 16 },
    { mask: '255.255.128.0', maskBits: 17 },
    { mask: '255.255.192.0', maskBits: 18 },
    { mask: '255.255.224.0', maskBits: 19 },
    { mask: '255.255.240.0', maskBits: 20 },
    { mask: '255.255.248.0', maskBits: 21 },
    { mask: '255.255.252.0', maskBits: 22 },
    { mask: '255.255.254.0', maskBits: 23 },
    { mask: '255.255.255.0', maskBits: 24 },
    { mask: '255.255.255.128', maskBits: 25 },
    { mask: '255.255.255.192', maskBits: 26 },
    { mask: '255.255.255.224', maskBits: 27 },
    { mask: '255.255.255.240', maskBits: 28 },
    { mask: '255.255.255.248', maskBits: 29 },
    { mask: '255.255.255.252', maskBits: 30 },
    { mask: '255.255.255.254', maskBits: 31 },
    { mask: '255.255.255.255', maskBits: 32 },
  ];
  
  export default subnetMaskOptions;
  